module.exports = __webpack_public_path__ + "img/owlens-top-logo - 복사본.275165c8.png";